'use strict';

import preact from 'preact';
import React from 'react';

require('./onboarding.less');

let template = require('./onboarding.html.rt');

class Onboarding extends preact.Component {
    constructor() {
        super();
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    render(props, state) {
        return template.call(this);
    }
}

let app = angular.module('app');

let onboardingDirective = function (reactDirective) {
    return reactDirective(Onboarding);
};
onboardingDirective.$inject = ['reactDirective'];
app.directive('reactOnboarding', onboardingDirective);

export default onboardingDirective;



// WEBPACK FOOTER //
// .-dna/app/components/onboarding/react-components.js